import momentJalaali from "moment-jalaali";
import colors from "../assets/scss/variable/color.scss";
import _isMatch from "lodash/isMatch";
import Storage from "./Storage";
import moment from "jalali-moment";

class snippets {

    static isObjectEmpty = (objectName) => {
        if (objectName === null || objectName === undefined) { return true }
        if (objectName === ''){return true}
        if (typeof objectName === 'number' && !isNaN(objectName)) {return false}
        if (typeof objectName === 'boolean') {return false}
        if (objectName instanceof Set) {
            return objectName.size === 0
        }
        if (Array.isArray(objectName) && objectName.length === 0) {return true}
        if (typeof objectName === 'object' && objectName?.size === 0) {return true}
        if (typeof objectName === 'object' && Object.keys(objectName).length === 0) {return true}
        for (let prop in objectName) {
            if (objectName.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    };

    static toFarsiNumber(n) {
        const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

        try {
            return n
                .toString()
                .replace(/[0-9]/g, x => farsiDigits[englishDigits.indexOf(x)]);
        } catch (error) {
            return n;
        }

    }

    static toEnglishNumber(n) {
        const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

        try {
            return n
                .toString()
                .replace(/[۰-۹]/g, x => englishDigits[farsiDigits.indexOf(x)]);
        } catch (error) {
            return n;
        }
    }
	
	static commaSeperator(number, lang='fa') {
		if (lang === 'fa') return Number(number).toLocaleString('fa-IR')
		else Number(number).toLocaleString('en-US')
	}

    static datetime(date) {
        if (this.isObjectEmpty(date)) return date
        let calendarType = Storage.getCalendar();
        let dateFormat = calendarType === "Gregorian" ?
            {
                locale: "en",
                format: "YYYY/MM/DD"
            } : {
                locale: "fa",
                format: "jYYYY/jMM/jDD"
            };
        return moment.from(date, "en", "YYYY-MM-DD").locale(dateFormat?.locale).format(dateFormat?.format)
    };

    static datetime2time(date) {
        if (this.isObjectEmpty(date)) return date
        return new Date(date).toLocaleTimeString('en-US', {hour12: false})
    };

    static time_today(calendarType = "Gregorian") {
        let dateFormat = "jYYYY/jMM/jDD";
        if (calendarType === "Gregorian") {
            dateFormat = "YYYY-MM-DD";
        }
        let today = new Date();
        // let date_now = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() ;
        let date_now = momentJalaali(today).format(dateFormat)
        let time_now =  today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return [date_now, time_now]
    }

    static time_days_before(n, calendarType = "Gregorian") {
        if (n === null) return "-"
        let dateFormat = "jYYYY/jMM/jDD";
        if (calendarType === "Gregorian") {
            dateFormat = "YYYY-MM-DD";
        }
        let now = new Date();
        const daysDiffers = new Date();
        daysDiffers.setDate(now.getDate() + n);
        return momentJalaali(daysDiffers).format(dateFormat)
    }

    static time_convert_to_shamsi(day) {
        let dateFormat = "jYYYY/jMM/jDD";
        const specificDate = new Date(day.substring(0,4), day.substring(5,7), day.substring(8,10));
        return momentJalaali(specificDate).format(dateFormat)
    }

    static dec2bin(dec) {
        return (dec >>> 0).toString(2);
    }

    static minTwoDigits = (n) =>{
        //uses in minutes less than 10 to be two-digit number.
        //it has bug on numbers with XX.000 that converts them to XX like 1232.0 => 1232
        return (n < 10 ? '0' : '') + n;
    }

    static getEtag = (response) =>{
        return response.headers['etag']?.replace("\"", "").replace('"',"").replace("'","")
    }

    static checkBrowser = () => {
        let match = window.navigator.userAgent.match(/(?:Chrom(?:e|ium)|Firefox|Safari)\/([0-9]+)\./);
        if (!match) {
            return false;
        }
        let browser = match[0].split('/')[0];
        let version = match ? parseInt(match[1], 10) : 0;
        if (version < 60){
            console.log('version', version, 'is less than 60 for browser', browser);
            return false;
        }
        return true;
    }

    static description = (className= "", description= null) => {
        return(
            <div className={className} style={{color: colors.white_b2}}>
                <ul>
                    <li>
                        {description}
                    </li>
                </ul>
            </div>
        )
    }

    static areObjectsEqual(obj1, obj2) {
        //this line because of checking undefined or nullity of one of these!
        if (!(obj1 && obj2)) return false

        const commonKeys = Object.keys(obj1).filter(key => obj2.hasOwnProperty(key));
        let ob1 = {}
        let ob2 = {}
        commonKeys.map(item => {
            ob1[item] = obj1[item]
            ob2[item] = obj2[item]
        })
        return _isMatch(ob1, ob2)
    }

    static objectsDifferKeys(obj1, obj2) {
        //this line because of checking undefined or nullity of one of these!
        if (!(obj1 && obj2)) return false

        const commonKeys = Object.keys(obj1).filter(key => obj2.hasOwnProperty(key));
        let ob1 = {}
        let ob2 = {}
        return commonKeys.filter(key =>  JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key]) )
    }

    static addElementToSetInObject(obj, key, item) {
        if (!obj[key]) {
            obj[key] = new Set();
        }
        obj[key].add(item);
        // return obj
    }

    static notNullObjectValues(obj){
        return Object.keys(obj).reduce((acc, key) => {
        if (!this.isObjectEmpty(obj[key])) {
          acc[key] = obj[key];
        }
        return acc;
      }, {});
    }

    static randomKey() {
        return Math.random()
    }
}

export default snippets;